import React, { useMemo, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { reactSelectStyles } from 'utils/style/select';
import { useTranslation } from 'react-i18next';
import { patchUserLanguage } from 'utils/network/http';
import { useAuth } from 'hooks/useAuth/useAuth';
import Spinner from 'components/Spinner';

const LanguageSelect = ({ className }) => {
  const { t, i18n } = useTranslation('AccountSettings');
  const { profile } = useAuth();
  const options = useMemo(
    () => [
      { value: 'en', label: t('languageEnglish') },
      { value: 'es', label: t('languageSpanish') },
      { value: 'fr', label: t('languageFrench') },
      { value: 'nl', label: t('languageDutch') },
      { value: 'pl', label: t('languagePolish') }
    ],
    [t]
  );
  const [loading, setLoading] = useState(false);

  const handleLanguageChange = useCallback(
    async option => {
      try {
        setLoading(true);
        await patchUserLanguage(profile.user.id, option.value);
      } catch (e) {
        console.error('Error patchUserLanguage', e);
      } finally {
        i18n.changeLanguage(option.value);
        setLoading(false);
      }
    },
    [i18n, profile]
  );

  if (!profile) return null;

  return (
    <div className={className} data-testid="language-select">
      <div className="language-select" data-testid="language-select__wrapper">
        {!loading && (
          <Select
            name="language"
            options={options}
            placeholder={t('language')}
            styles={reactSelectStyles}
            onChange={handleLanguageChange}
            value={options.find(option => option.value === i18n.language)}
          />
        )}
        {loading && (
          <div className="language-select__loading">
            <Spinner noBackdrop />
          </div>
        )}
      </div>
    </div>
  );
};

LanguageSelect.propTypes = {
  className: PropTypes.string
};

export default LanguageSelect;
